import Hero from "../components/Hero";
import ClientLogos from "../components/ClientLogos";
import Services from "../components/Services";
import CaseStudies from "../components/CaseStudies";
import Process from "../components/Process";
import ContactCTA from "../components/ContactCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <ClientLogos />
      <Services />
      <CaseStudies />
      <Process />
      <ContactCTA />
    </>
  );
}
